import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const VALUABLES = {
  nickname: 'PRODUCTS.VALUABLES.nickname',
  properties: [
    { name: 'wtcValuablesObjectType', key: 'WTC_VALUABLES_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.ELECTRONIC_EQUIPMENT',
            value: 'ELECTRONIC_EQUIPMENT', isSerialNumber: true },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.BUNAD_WITH_SILVER', value: 'BUNAD_WITH_SILVER', isSerialNumber: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.MEDIA_EQUIPMENT', value: 'MEDIA_EQUIPMENT', isSerialNumber: true },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.GOLF_EQUIPMENT', value: 'GOLF_EQUIPMENT', isSerialNumber: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.HOBBY_EQUIPMENT', value: 'HOBBY_EQUIPMENT', isSerialNumber: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.HEARING_AID', value: 'HEARING_AID', isSerialNumber: true },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.INSTRUMENT_AND_MUSIC_SYSTEM',
            value: 'INSTRUMENT_AND_MUSIC_SYSTEM', isSerialNumber: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.ART', value: 'ART', isSerialNumber: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.FUR', value: 'FUR', isSerialNumber: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.JAWERLY', value: 'JAWERLY', isSerialNumber: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.SPORTS_EQUIPMENT', value: 'SPORTS_EQUIPMENT', isSerialNumber: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.SILVERWARE', value: 'SILVERWARE', isSerialNumber: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.UR', value: 'UR', isSerialNumber: true },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.WEAPON', value: 'WEAPON', isSerialNumber: true }
        ]
      }
    },
    { name: 'wtcValuablesValidAbroad', key: 'WTC_INSURANCE_COMPANY_ABROAD', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'wtcObjectValue', key: 'WTC_OBJECT_VALUE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcSerialNumber', key: 'WTC_SERIAL_NUMBER', group: 'OBJECT_INFO'},
    { name: 'wtcValuablesDescription', key: 'WTC_VALUABLES_DESCRIPTION', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    }
  ],
  icon:'valuables'
};
